module.exports = __webpack_public_path__ + "img/yunTop.2cc6af59.png";